import { format } from 'date-fns';
import { formatDuration } from 'date-fns';
import { intervalToDuration } from 'date-fns';
import { de } from 'date-fns/locale';

let DateUtils = {
    formatTimestamp: function (timestamp) {
        if (null == timestamp) {
            return null;
        } else {
            return format(timestamp, 'PP', { locale: de });
        }
    },

    formatReadingTimeDuration: function (minutes) {
        if (null == minutes) {
            return null;
        } else {
            let duration = intervalToDuration({
                start: new Date(1980, 12, 1, 0, 0, 0),
                end: new Date(1980, 12, 1, 0, minutes, 0),
            });

            return formatDuration(duration, {
                locale: de,
                format: ['hours', 'minutes'],
            });
        }
    },
};

export default DateUtils;
